import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

import { OrdersService } from 'src/app/core/services/orders.service';

@Component({
  selector: 'app-order-history-timeline-popup',
  templateUrl: './order-history-timeline-popup.component.html',
  styleUrls: ['./order-history-timeline-popup.component.scss']
})
export class OrderHistoryTimelinePopupComponent implements OnInit {
  @Input() mode: 'order' | 'orderItem' = 'order';
  @Input() targetId: number | null = null;
  @Input() referenceNo = '';

  isLoading = false;
  errorMessage = '';
  events: any[] = [];

  constructor(
    public activeModal: NgbActiveModal,
    private ordersService: OrdersService
  ) { }

  ngOnInit(): void {
    this.loadHistory();
  }

  get title(): string {
    return this.mode === 'orderItem' ? 'Order Item History' : 'Order History';
  }

  get subtitle(): string {
    return this.referenceNo ? `Timeline for ${this.referenceNo}` : 'Timeline of changes';
  }

  get emptyMessage(): string {
    return this.mode === 'orderItem'
      ? 'No order item history found.'
      : 'No order history found.';
  }

  getStatusLabel(event: any): string {
    if (!event) {
      return '-';
    }
    const raw = this.mode === 'orderItem'
      ? (event.orderItemStatus || event.statusLabel || '')
      : (event.orderStatus || event.statusLabel || '');
    return this.formatLabel(raw) || '-';
  }

  getStateLabel(event: any): string {
    return this.formatLabel(event?.orderState) || '-';
  }

  getCommentLabel(event: any): string {
    return String(event?.comment || '').trim() || '-';
  }

  getActorLabel(event: any): string {
    return event?.audit?.createdByName || event?.audit?.updatedByName || '-';
  }

  private loadHistory(): void {
    if (!this.targetId) {
      this.errorMessage = 'Invalid history target.';
      return;
    }

    this.isLoading = true;
    const request$ = this.mode === 'orderItem'
      ? this.ordersService.getOrderItemAudit(this.targetId)
      : this.ordersService.getOrderHistory(this.targetId);

    request$.subscribe(
      (res: any) => {
        this.isLoading = false;
        if (res?.isError) {
          this.errorMessage = 'Unable to load history.';
          return;
        }
        const data = res?.data || {};
        const rawEvents = this.mode === 'orderItem'
          ? (data.orderItemStatusUpdates || [])
          : (data.orderStatusUpdates || []);
        this.events = Array.isArray(rawEvents) ? rawEvents : [];
      },
      () => {
        this.isLoading = false;
        this.errorMessage = 'Unable to load history.';
      }
    );
  }

  private formatLabel(value: any): string {
    const raw = String(value || '').trim();
    if (!raw) {
      return '';
    }
    return raw
      .replace(/([a-z])([A-Z])/g, '$1 $2')
      .replace(/_/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();
  }
}
